import { useParams } from "react-router-dom"
import Page from "components/Page"
import OwnedProjects from "components/OwnedProjects"
import usePageMeta from "hooks/usePageMeta"

const UserPage = () => {
  const { walletAddress } = useParams()
  usePageMeta(
    walletAddress ? "Collection — r4v3n" : undefined,
    undefined,
    undefined,
    walletAddress ? `/user/${walletAddress}` : undefined,
  )
  return (
    <Page>
      {
        walletAddress && <OwnedProjects walletAddress={walletAddress.toLowerCase()}/>
      }
    </Page>
  )
}

export default UserPage
